import { AgsOverAnimateThreshold } from "ags/state-machine/decisions/ags-over-threshold";
import { AgsHighlightWins } from "ags/state-machine/states/ags-highlight-wins";
import { AgsIsRecoveryPick } from "ags/state-machine/states/ags-is-recovery-pick";
import { AgsRollUp } from "ags/state-machine/states/ags-roll-up";
import { stateMachine } from "appworks/state-machine/state-machine";
import { GameiomGameOverState } from "gameiom/states/gameiom-game-over";
import { GameiomRecovery } from "gameiom/states/gameiom-recovery";
import { IsAutoplayDecision } from "slotworks/state-machine/standard/decisions/is-autoplay-decision";
import { IsRecoveryDecision } from "slotworks/state-machine/standard/decisions/is-recovery-decision";
import { IsWinDecision } from "slotworks/state-machine/standard/decisions/is-win-decision";
import { AutoplayState } from "slotworks/state-machine/standard/states/autoplay-state";
import { RecoverMatrixState } from "slotworks/state-machine/standard/states/recover-matrix-state";
import { RecoverSpinState } from "slotworks/state-machine/standard/states/recover-spin-state";
import { RecoverState } from "slotworks/state-machine/standard/states/recover-state";
import { ThemeGameiomRequestSpin } from "states/theme-gameiom-request-spin";
import { ThemeInit } from "states/theme-init";
import { ThemeLoopWinsState } from "states/theme-loop-wins-state";
import { ThemeSparkSpin } from "states/theme-spark-spin";
import { ThemeGameiomIdle } from "states/theme-gameiom-idle";
import { AutoplayDelayState } from "slotworks/state-machine/standard/states/autoplay-delay-state";

export function ThemeStateSetup(): void {
    // Decisions
    const isRecovery = new IsRecoveryDecision();
    const isRecoveryPick = new AgsIsRecoveryPick();
    const isWinCheck = new IsWinDecision();
    const isOverHighlightThreshold = new AgsOverAnimateThreshold();
    const gameOverIsAutoplay = new IsAutoplayDecision();
    const winCycleAutoplayCheck = new IsAutoplayDecision();
    const isAutoplay = new IsAutoplayDecision();

    // States
    const init = new ThemeInit();
    const gameiomRecovery = new GameiomRecovery();
    const spin = new ThemeSparkSpin({ enableSafetyCheck: false });
    const idle = new ThemeGameiomIdle();
    const recoverSpin = new RecoverSpinState();
    const gameiomGameOver = new GameiomGameOverState();
    const gameiomAutoplay = new AutoplayState();
    const gameiomAutoplayDelay = new AutoplayDelayState(300);
    const gameiomRequestSpin = new ThemeGameiomRequestSpin();
    const loopWins = new ThemeLoopWinsState();
    const recover = new RecoverState();
    const highlightWins = new AgsHighlightWins();
    const rollUp = new AgsRollUp();
    const pickRecovery = new RecoverMatrixState();

    stateMachine.addStates([
        { state: init, links: { complete: isRecovery }, entryPoint: true },
        { state: gameiomRecovery, links: { complete: isRecoveryPick } },
        { state: idle, links: { skip: isAutoplay, complete: isAutoplay } },
        { state: gameiomRequestSpin, links: { complete: spin, skip: spin, error: idle }, cascadeSkip: true },
        { state: spin, links: { complete: isWinCheck } },
        { state: gameiomGameOver, links: { complete: gameOverIsAutoplay } },
        { state: gameiomAutoplayDelay, links: { complete: gameiomAutoplay, skip: gameiomAutoplay, error: idle } },
        { state: gameiomAutoplay, links: { complete: gameiomRequestSpin, skip: gameiomRequestSpin } },
        { state: recover, links: { complete: isWinCheck } },
        { state: recoverSpin, links: { complete: spin } },
        { state: loopWins, links: { complete: winCycleAutoplayCheck, skip: "exit-1" } },
        { state: highlightWins, links: { complete: rollUp } }
    ]);
    stateMachine.addDecisions([
        { decision: isOverHighlightThreshold, links: { true: highlightWins, false: rollUp } },
        { decision: isRecovery, links: { true: gameiomRecovery, false: idle } },
        { decision: isRecoveryPick, links: { true: pickRecovery, false: recoverSpin } },
        { decision: isWinCheck, links: { true: isOverHighlightThreshold, false: gameiomGameOver } },
        { decision: gameOverIsAutoplay, links: { true: gameiomAutoplayDelay, false: idle } },
        { decision: isAutoplay, links: { true: gameiomAutoplayDelay, false: gameiomRequestSpin}},
        { decision: winCycleAutoplayCheck, links: { true: "exit-2", false: loopWins } }
    ]);

    stateMachine.addSuperStates([
        {
            superState: rollUp,
            entrySubState: loopWins,
            links: {
                "exit-1": gameiomRequestSpin,
                "exit-2": gameiomAutoplayDelay,
                "collapse": idle
            }
        }
    ]);
}
